export const comparisonOptions = [
  { label: 'Greater than', value: 'GREATER_THAN' },
  { label: 'Greater than or equal to', value: 'GREATER_THAN_OR_EQUAL' },
  { label: 'Less than', value: 'LESS_THAN' },
  { label: 'Less than or equal to', value: 'LESS_THAN_OR_EQUAL' },
  { label: 'Between', value: 'IN_RANGE' },
  { label: 'Equals', value: 'EQUALS' },
];

export const excludedPrompts = ['comparison_period', 'purchase_shift'];

export const testPanelSurveyComparisonOptions = [
  { label: 'Greater than', value: 'GREATER_THAN' },
  { label: 'Greater than or equal to', value: 'GREATER_THAN_OR_EQUAL' },
];
